// extracted by mini-css-extract-plugin
export default {"container":"beam-circular-progress_container__PSR8l"};